














































































































import { Component, Prop, Vue } from 'vue-property-decorator';

import Loading from '@/components/Loading.vue';
import Error from '@/components/Error.vue';
import Success from '@/components/Success.vue';
import SectionHeader from '@/components/SectionHeader.vue';
import { ApiClient, curApiClient } from '@/services/ApiClient';
import { EnrolProfileActility } from '@/types';

@Component({
  components: {
    Loading,
    Error,
    SectionHeader,
    Success
  },
})
export default class CreateEnrolProfile extends Vue {

  @Prop({ default: () => [],  type: Array}) enrolProfileIdList!: string[];

  // our model
  error:string = '';
  success:string = '';

  // our model
  enrolId = "";
  description = "";
  actility:EnrolProfileActility = {} as EnrolProfileActility;
  
  httpBusy = false;
  
  // internal dependencies
  private apiClient:ApiClient = curApiClient;
  
  async mounted() {
    
  }
  
  get canCreate():boolean {
    return !this.httpBusy;
  }

  async doCreate() {

    this.httpBusy = true;
    this.error = '';

    let newEnrolProfileReq = {
      enrolId: this.enrolId,
      description: this.description,
      type:'actility' as 'actility',
      actility: Object.assign({}, this.actility)
    }

    const reply = await this.apiClient.createEnrolProfile(newEnrolProfileReq);

    this.httpBusy = false;
    
    if(reply.errorMsg)
      return this.error = `unable to create enrol profile: ${reply.errorMsg}`;

    this.setSuccess(`enrol profile ${this.enrolId} created successfully`);
  }

  setSuccess(str:string) {
    this.success = str;
    setTimeout(() => this.$emit('cancel'), 2000);
  }

  cancel() {
    this.$emit('cancel');
  }
}
